import { useForm } from "react-hook-form";
import { AnswerInput } from "../AnswerInput";
import { MultipleAnswerInput } from "../MultipleAnswerInput";
import { useEffect, useRef } from "react";
import { getStep2Data } from "../../helper";
import { Chip } from "../Chip";
import { CollapsibleCard } from "../Accordian";
import { LessonRevelationCard } from "../LessonRevelationCard";

export const Step2 = ({
  questions = [],
  answers = {},
  updateAnswer,
  warmapQuestionResponse = {},
}) => {
  const step2Data = getStep2Data(warmapQuestionResponse);


  const defaultValues = questions.reduce((acc, question) => {
    if (!question.allow_multiple_answers) {
      acc[String(question.id)] =
        answers[question.id] || question?.answer?.answer_text || "";
    }
    return acc;
  }, {});

  const { control, setValue } = useForm({
    defaultValues,
  });

  const prevAnswersRef = useRef(answers);

  useEffect(() => {
    questions.forEach((question) => {
      if (!question.allow_multiple_answers) {
        const questionId = String(question.id);
        const currentAnswer = answers[question.id];
        const prevAnswer = prevAnswersRef.current[question.id];

        if (currentAnswer !== prevAnswer && currentAnswer !== undefined) {
          setValue(questionId, currentAnswer, { shouldDirty: false });
        }
      }
    });

    prevAnswersRef.current = { ...answers };
  }, [answers, questions, setValue]);

  return (
    <div className="d-flex flex-column w-full" style={{ gap: "24px" }}>
      {/* Chip Data part */}
      <div className="d-flex flex-row justify-content-around align-items-center w-full">
        <Chip
          label="Daily AM Journal"
          content={`${step2Data.completedAmReflectionCount} / 7`}
        />
        <Chip
          label="Daily PM Reflection"
          content={`${step2Data.completedAmReflectionCount} / 7`}
        />
        <Chip
          label="Total Journal Entries"
          content={step2Data.total_submitted_journal_entries_count}
        />
      </div>

      <div>
        <CollapsibleCard title="My Lessons and Revelations this week">
          <LessonRevelationCard
            lessonRevelation={step2Data.lession_and_revelations}
          />
        </CollapsibleCard>
      </div>
      {questions?.length > 0 &&
        questions.map((question) => {
          if (question.allow_multiple_answers) {
            return (
              <MultipleAnswerInput
                key={question.id}
                questionId={question.id}
                label={question.question_text}
                defaultValue={
                  answers[question.id] || question?.answer?.answer_text || ""
                }
                onValueChange={(value) => {
                  if (updateAnswer) {
                    updateAnswer(question.id, value);
                  }
                }}
              />
            );
          }

          return (
            <AnswerInput
              control={control}
              key={question.id}
              name={String(question.id)}
              label={question.question_text}
              defaultValue={
                answers[question.id] || question?.answer?.answer_text || ""
              }
              onValueChange={(value) => {
                if (updateAnswer) {
                  updateAnswer(question.id, value);
                }
              }}
            />
          );
        })}
    </div>
  );
};
